import { SidebarService } from '../services/sidebar.service';
import { ConfigService } from './../services/config.service';
import { Component, OnInit } from '@angular/core';

declare function inicializarCustomJs(): void;

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styles: [
  ]
})
export class PagesComponent implements OnInit {
  ano: number = new Date().getFullYear();

  constructor(
    public configService: ConfigService,
    private sidebarSrv: SidebarService
  ) { }

  ngOnInit(): void {
    // inicializar los plugIn's y demás js del tema
    inicializarCustomJs();

    // Cargar el menu
    this.sidebarSrv.cargarMenu();

    // Tema guardado o por defecto
    this.configService;
  }

}
